import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
// import { StateService } from '@uirouter/angular';

import { ContentJobsService } from './../content-jobs.service';
import { SocketService, SocketLog } from './../../../services/socket.service';

@Component({
	selector: 'app-jobs-upload-logs',
	templateUrl: './jobs-upload-logs.component.html',
	styleUrls: ['./jobs-upload-logs.component.css']
})
export class JobsUploadLogsComponent implements OnInit, OnDestroy {

	// // Logs of current process
	// public socketMsg: SocketMessageFE[] = [];
	//
	// public disableView = true;
	//
	public title = 'Uploading Logs';
	public currentLog: SocketLog;

	public withQC = false;
	// The page is directed to through wizard (vs jumped to from other pages)
	public isWizard: boolean;
	//
	private logsSub: Subscription;
	private paramsSub: Subscription;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		// private stateService: StateService,
		private jobsService: ContentJobsService,
		private socketService: SocketService
	) { }

	viewData() {
		// this.stateService.go('jobsfilesreview');
		this.router.navigate(['azgiv/review/data-view']);
	}
	goPrev() {
		// this.stateService.go('jobsfieldmapping');
		// this.router.navigate(['azgiv/jobs/field-mapping']);
		this.router.navigate(['azgiv/jobs/add-files']);
	}
	goNext() {
		// this.stateService.go('jobsfilesreview', {
		// 	wizard: 'on'
		// });
		if (!this.withQC) {
			this.router.navigate(['azgiv/review/data-view']);
		} else {
			this.router.navigate(['azgiv/review/qc-view']);
		}
	}
	ngOnInit() {
		//
		// this.isWizard = this.stateService.params.wizard === 'on';
		this.isWizard = this.jobsService.wizard === 'on';
		// Get processId from parameters
		let processId;
		this.paramsSub = this.route.paramMap.subscribe((params) => {
			processId = params.get('processId');
		});
		//
		this.logsSub = this.jobsService.uploadingLogs.subscribe((data) => {
			// const processId = this.stateService.params.processId;
			console.log('process iddddddddddd: ', processId);
			this.currentLog = this.socketService.getCurrentSocketLog(processId, data);
			// if (this.jobsService.uploadWithQcProcesses[processId]) {
			// 	this.withQC = true;
			// } else {
			// 	this.withQC = false;
			// }
		});
	}
	ngOnDestroy() {
		this.logsSub.unsubscribe();
		this.paramsSub.unsubscribe();
	}
}
